import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type UseSelfieValidationParams = {
  sessionId: string
}

export function useSelfieValidation({ sessionId }: UseSelfieValidationParams): { progress: number } {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (sessionId === '') return;

    setProgress(40);
    const timer = window.setTimeout(() => {
      setProgress(100);
      navigate('/signup', { replace: true });
    }, 600);

    return () => {
      window.clearTimeout(timer);
    };
  }, [sessionId, navigate]);

  return { progress };
}
